import { EMPLOYEE_TYPES_ALIAS } from './constants';
import { isPolishOffice } from './officeService';
import { POLAND } from 'framework/form';

type PolishContractorProps = {
  employeeType?: string | null;
  officeId?: string | number | null;
  businessRegistrationCountry?: string | null;
};

export const isPolishContractorByEmployeeType = (employee?: PolishContractorProps) => {
  if (!employee || employee.employeeType !== EMPLOYEE_TYPES_ALIAS.CONTRACTOR) return false;

  return isPolishOffice(String(employee.officeId)) || employee.businessRegistrationCountry === POLAND.name;
};
